export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 03 Third Floor Spending Spree.9f67907a.mp3";